export default {"src":"/_next/static/media/aligned-face.c0c64096.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};